import React from 'react';
import { Building02Icon } from 'hugeicons-react';

function CondoTownhouse(props) {
    const className = props.className;
    const fill = props.fill;
    const size = props.size;
    return (
        <Building02Icon
            className={className}
            fill={fill}
            size={size}
        />
    )
};

export default CondoTownhouse;